/** Prints the hidden sale-bill copy. Call only while `SaleBillPrintCopy` is mounted. */
export function printSaleBill() {
  document.body.classList.add('sale-bill-printing');
  const cleanup = () => document.body.classList.remove('sale-bill-printing');
  window.addEventListener('afterprint', cleanup, { once: true });
  window.print();
  cleanup();
}
